import React, { Component, Fragment } from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Link } from 'react-router-dom';
import { Container,Row,Col,Button} from 'react-bootstrap'
import Product1 from '../../assets/images/product/pospressoplus.png'





class PospressoPlus extends Component {
     render() {
          return (
               <Fragment>
              <Container fluid={true}  className="BetweenTwoSection">
                  <div className="breadbody">
                <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to="/products"> Product </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/pospresso_plus"> PospressoPlus </Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>
<div className="d-flex justify-content-between align-items-center mb-2">
  <h2 className="section-title text-primary m-0"></h2>

  <Link to="/PospressoPlusLive">
             
            
        
           <Button size="sm" variant="primary">
                Live Demo
           </Button>
           </Link>
       
</div>

  <h2 className="section-title text-center mb-2 text-primary">POSPRESSO PLUS</h2>
   

<p className="text-center mb-3">Complete POS for Hotels, Restaurants & Vehicle Services</p>
    
                   <Row className="p-2">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
          

     <img  className="product-main"  src={Product1}  alt="ParkEase Dashboard"/>
          <Container  className="my-3">
               
          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
          <h5 className="Product-Name">PospressoPlus</h5>
          
          <p>Pospresso Plus is the enhanced version of Pospresso, designed to manage not only hotel and restaurant operations but also vehicle services such as parking and wash bays. It provides a seamless experience for staff, customers, and management by integrating order management, billing, and vehicle service tracking into a single platform</p>
          <div className="">
           <h6> Key Differences from Pospresso</h6>
          <p>While Pospresso focuses on hotel and restaurant POS functions, Pospresso Plus extends its capabilities to vehicle services:
              </p>
<ul>
          <li>Full access to the system.</li>
               <li>Vehicle Registration: Vehicles are registered upon arrival for parking or wash bay services.</li>
               <li>Service Selection: Staff or customers select the desired service (e.g., parking, car wash, detailing).</li>
               <li>Service Charging & Invoicing: Charges are calculated automatically, and invoices are printed by the cashier or admin.</li>
               <li>Vehicle Tracking: Admin and staff can track the status of each vehicle as services are performed.</li>

</ul>
              



           
          </div>


        
          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">KEY FEATURES</h6>
          <ul>
               <li>Integrated Operations: Combines hotel/restaurant POS with vehicle service management.</li>
               <li>Order & Service Management: Efficiently handle both customer orders and vehicle services.</li>
               <li>Billing & Invoicing: Print invoices and receipts for both restaurant and vehicle services.</li>
               <li>Dashboard & Reporting: Admin can view daily transactions, staff performance, and revenue from all services.</li>
               <li>Customer Convenience: Quick registration, service selection, and seamless payment processing.</li>
          </ul>
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h4>User Roles and Permissions</h4>
                <h4>Admin, Cashier and Waiter</h4>
          
           <ul>
               <li>Registers vehicles upon arrival.</li>
               <li>Assigns services to each vehicle.</li>
               <li>Tracks completion.</li>
           </ul>
                     <h4>Admin</h4>
                     <p>Admin has permission setting Charges and editing them.</p>
<p> invoice/payment is processed and the reciept is printed</p>


           <h4>Cashier</h4>
<p> ensures invoice/payment is processed and the reciept is printed</p>



          </Col>
     </Row>

</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default PospressoPlus